import {Checkbox, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";

export type GlazingPageItem = "summary" | "frameGlazing" | "doorGlazing";

const allPages: {key: GlazingPageItem; label: string}[] = [
    {key: "summary", label: "Summary"},
    {key: "frameGlazing", label: "Frame Glazing"},
    {key: "doorGlazing", label: "Door Glazing"},
];

export const defaultGlazingPages: GlazingPageItem[] = allPages.map(p => p.key);

// pick which sections the glazing submittal prints.
export function GlazingPagesTab(props: {
    value: GlazingPageItem[];
    onChange(value: GlazingPageItem[]): void;
}) {
    return (
        <List dense>
            {allPages.map(p => (
                <ListItemButton key={p.key} onClick={() => {
                    if(props.value.includes(p.key)) {
                        props.onChange(props.value.filter(v => v !== p.key));
                    } else {
                        props.onChange([...props.value, p.key]);
                    }
                }} dense>
                    <ListItemIcon>
                        <Checkbox
                            edge="start"
                            checked={props.value.includes(p.key)}
                            tabIndex={-1}
                            disableRipple
                        />
                    </ListItemIcon>
                    <ListItemText primary={p.label} />
                </ListItemButton>
            ))}
        </List>
    );
}
